<template>
  <li class="dropdown_menu" :class="mainanalyticsListCssObj">
    <a v-b-toggle.reportCollapse @click.prevent="toggleCollapse">
      <b-icon-clipboard></b-icon-clipboard>
      <span class="link-title menu_hide ml-1">รายงาน</span>
      <span class="fa arrow menu_hide"></span>
    </a>

    <b-collapse id="reportCollapse" :visible="false" accordion="accordion">
      <main-analytics-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainAnalyticsCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import CompanySideBars from "../CompanySidebarSwitch";
import _ from "lodash";
import authMixin from "@/mixins/auth-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainAnalyticsCollapseMenu,
  },
  mixins: [authMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
      comId: this.$store.state.Company.companyInfo.id,
    };
  },
  computed: {
    mainanalyticsListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  async mounted() {
    if (
      await checkSubMenuAccess(
        { menu: "tfac-purchase-summary-by-course-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานสรุปการขายรายหลักสูตร",
        to: {
          name: "report.tfac.purchasesummarybycoursereport",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "tfac-revenue-summary-by-course-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานการรับรู้รายได้",
        to: {
          name: "report.tfac.report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "tfac-enroll-summary-by-course-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานสรุปจำนวนผู้สมัครเรียนแยกตามหลักสูตร",
        to: {
          name: "report.tfac.enrollsummarybycoursereport",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "trial-course-history-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานการทดลองเรียน",
        to: {
          name: "report.trial-course-enrollment-report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "student-count-by-school-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานสรุปจำนวนผู้เรียนแยกตามโรงเรียน",
        to: {
          name: "report.student-count-by-school-report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "student-course-summary-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานสรุปจำนวนคอร์สแยกตามผู้เรียน",
        to: {
          name: "report.student-course-summary-report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "student-info-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานข้อมูลนักเรียน",
        to: {
          name: "report.student-info-report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "learning-history-summary-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานสรุปประวัติการเรียน",
        to: {
          name: "report.learning-history-summary-report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "tfac-individual-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานข้อมูลผู้เรียนรายบุคคล",
        to: {
          name: "report.tfac.individualstudentfile",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "tfac-completed-enoll-by-date-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานการจบคอร์สและสอบผ่าน",
        to: {
          name: "report.tfac.completedEnrollByDateReport",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "thaire-completed-courses-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานการจบคอร์สและสอบผ่าน",
        to: {
          name: "report.thaire.completedCoursesReport",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "learning-history-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "ประวัติการเข้าเรียน",
        to: {
          name: "report.learning-history-report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "exam-detailed-result-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานผลการสอบ",
        to: {
          name: "report.exam-detailed-result-report",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "course-sales-history-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานการขายหลักสูตร",
        to: {
          name: "report.course-sales-history-report",
        },
      });
    }
  },
  methods: {
    ...CompanySideBars,
    checkAuthorizationRoles(roles = []) {
      const companyId = this.$store.state.Company.companyInfo.id;
      const userRoles = this.$store.state.Authentication.authUser.roles
        .filter((el) => el.companyId === companyId)
        .map((el) => el.roleName);
      for (let role of roles) {
        if (userRoles.includes(role)) return true;
      }
      return false;
    },
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
